export default __webpack_public_path__ + "static/sirage-9582a42179948a96e4a6c8d552e78343.webp";